"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageQuoteFull = void 0;
var react_1 = __importStar(require("react"));
var crumbs_1 = require("../crumbs");
var react_router_dom_1 = require("react-router-dom");
require("./page.less");
var refresh_1 = require("../refresh");
var faketab_1 = require("./shared/faketab");
var fulltable_1 = require("../quotetable/fulltable");
/**
 * 可转债全屏table
 * @returns
 */
function PageQuoteFull() {
    var location = (0, react_router_dom_1.useLocation)();
    var hash_no_sharp = location.hash;
    if (hash_no_sharp.substring(0, 1) == '#') {
        hash_no_sharp = hash_no_sharp.substring(1);
    }
    (0, react_1.useEffect)(function () {
        window.scrollTo(0, 0);
    }, [hash_no_sharp]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "page_head_crumbs scf" },
            react_1.default.createElement("div", { className: "c" },
                react_1.default.createElement(crumbs_1.CrumbsFullPage, null)),
            react_1.default.createElement("div", { className: "r" })),
        react_1.default.createElement(faketab_1.FakeTab, { tabs: [{
                    on: true,
                    txt: "可转债比价表",
                    link: ""
                }, {
                    on: false,
                    txt: "可转债数据一览",
                    link: "http://data.eastmoney.com/kzz/default.html"
                }], right: react_1.default.createElement(refresh_1.RefreshBtn, null) }),
        react_1.default.createElement(fulltable_1.QuoteFullTable, null)));
}
exports.PageQuoteFull = PageQuoteFull;
